<div class="engagement-panel">
  @if (openUserRequestPopup) {
    <kendo-popup
      (close)="close()"
      [animate]="animate"
      [anchor]="anchor"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      popupClass="full-height-popup"
      [margin]="margin"
      >
      <div #popupContent class="add-client-container">
        <div class="popup-header">
          @if (!isAutoApprove) {
            <div class="popup-title user-request-header">Request User Addition</div>
          }
          @if (isAutoApprove) {
            <div class="popup-title">
              Request & Approve User Addition
            </div>
          }
          <button class="close-btn" (click)="close()">&#x2715;</button>
        </div>
        <div>
          @if (isDisplayloader) {
            <div class="setloader-position"
              >
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                size="default"
                color="#225EFF"
                type="ball-triangle-path" [fullScreen]="false">
              </ngx-spinner>
            </div>
          }
          @if (!isDisplayloader) {
            <div class="engagement-details-section">
              @if (userRequestDetailsForm) {
                <form
                  class="k-form k-form-md"
                  [formGroup]="userRequestDetailsForm"
                  >
                  <div style="border-bottom: 1px solid #e5e5e5">
                    Please fill out the following details to
                    add a user to the engagement. The information will be
                    automatically retrieved from Active Directory.
                  </div>
                  <div style="padding-top: 10px">Engagement</div>
                  <div>
                    <kendo-combobox
                      formControlName="engagementDetail"
                      [data]="searchedEngagementDetails"
                      textField="name"
                      valueField="engagementId"
                      [filterable]="true"
                      (filterChange)="searchEngagementDetailsListsByEngagementName($event)"
                      [rounded]="'small'" class="white-background-dropdown dropdown"
                      >
                      <ng-template kendoPrefixTemplate [showSeparator]="true">
                        <button
                          kendoButton
                          fillMode="flat"
                          [svgIcon]="searchIcon"
                        ></button>
                      </ng-template>
                    </kendo-combobox>
                  </div>
                  <div style="padding-top: 10px">Name</div>
                  <div>
                    <kendo-combobox
                      formControlName="userDetail"
                      [data]="searchedUserDetails"
                      textField="displayName"
                      valueField="id"
                      [filterable]="true"
                      (filterChange)="searchUserDetailsListsByUserName($event)"
                      [rounded]="'small'"
                      [loading]="isDisplayloaderUserSearch"
                      [value]="user" class="white-background-dropdown dropdown"
                      >
                      <ng-template kendoPrefixTemplate [showSeparator]="true">
                        <button
                          kendoButton
                          fillMode="flat"
                          [svgIcon]="searchIcon"
                        ></button>
                      </ng-template>
                    </kendo-combobox>
                  </div>
                  <div style="padding-top: 10px">Access/Role</div>
                  <div>
                    <kendo-dropdownlist
                      name="userRoles"
                      formControlName="userRoleDetail"
                      [data]="userRequestRoleTypes"
                      textField="description"
                      valueField="id"
                      class="dropdown"
                      >
                    </kendo-dropdownlist>
                  </div>
                </form>
              }
            </div>
          }
          @if (!isDisplayloader) {
            <div class="form-buttons">
              @if (isAutoApprove) {
                <button
                  kendoButton
                  type="button"
                  (click)="createUserRequestDetails()"
                  [disabled]="!userRequestDetailsForm.valid"
                  class="request-button"
                  themeColor="none"
                  >
                  REQUEST & APPROVE
                </button>
              }
              @if (!isAutoApprove) {
                <button
                  kendoButton
                  type="button"
                  (click)="createUserRequestDetails()"
                  [disabled]="!userRequestDetailsForm.valid || !isDataLoading"
                  class="request-button"
                  themeColor="none"
                  >
                  REQUEST
                </button>
              }
              <button
                kendoButton
                type="button"
                (click)="cancelUserRequestDetails()"
                style="width: 100%;background-color:#E0E0E0"
                >
                CANCEL
              </button>
            </div>
          }
        </div>
      </div>
    </kendo-popup>
  }
</div>

@if (openUserRequestPopup) {
  <div class="k-popup-backdrop"></div>
}
